import script from "./ReportTextForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportTextForm.vue?vue&type=script&setup=true&lang=js"

import "./ReportTextForm.vue?vue&type=style&index=0&id=40ba3ab6&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ba3ab6"]])

export default __exports__